import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from 'environments/environment';
import { notFramedGuard } from './shared/guards/not-framed.guard';
import { UnavailableGuard } from './shared/guards/unavailable.guard';
import { TailwindLibraryComponent } from './tailwind-library/tailwind-library.component';
import { UnavailablePageComponent } from './unavailable-page/unavailable-page.component';
import { PartnerContextGuard } from './white-label-client/shared/guards/partner-context.guard';

export const routedComponents = [TailwindLibraryComponent];

const routes: Routes = [
	{ path: '', pathMatch: 'full', redirectTo: '/login' },
	{ path: 'signup/partner-landing', redirectTo: '/partner/landing/default' },
	{ path: 'signup/:partner', redirectTo: '/partner/signup/:partner' },
	{
		path: 'getstarted',
		loadChildren: () => import('./signup/signup.module').then(m => m.SignupModule),
		canActivate: [notFramedGuard],
	},
	{ path: 'home', redirectTo: '/v2/home' },
	{
		path: 'partner',
		loadChildren: () => import('./partner/partner.module').then(m => m.PartnerModule),
		canActivate: [notFramedGuard],
	},
	{
		path: 'p/:partner',
		loadChildren: () => import('./white-label-client/white-label-client.module').then(m => m.WhiteLabelClientModule),
		canActivate: [UnavailableGuard, PartnerContextGuard],
	},
	{
		path: 'apply',
		loadChildren: () => import('./onboarding/onboarding.module').then(m => m.OnboardingModule),
		canActivate: [UnavailableGuard, notFramedGuard],
	},
	{
		path: 'partner-portal',
		loadChildren: () => import('./partner-portal/partner-portal.module').then(m => m.PartnerPortalModule),
		canActivate: [UnavailableGuard, notFramedGuard],
	},
	{
		path: 'login',
		loadChildren: () => import('./entry/entry.module').then(m => m.EntryModule),
		canActivate: [UnavailableGuard, notFramedGuard],
	},
	{
		path: 'v2',
		loadChildren: () => import('./my-froda/my-froda.module').then(m => m.MyFrodaModule),
		canActivate: [UnavailableGuard, notFramedGuard],
	},
	{ path: 'tailwind', component: TailwindLibraryComponent },
	{
		path: 'start',
		children: [
			{ path: 'new-customer', redirectTo: '/apply' },
			{ path: 'ref/korkortsjakten', redirectTo: '/apply/partner/korkortsjakten' },
			{ path: 'ref/bokadirekt', redirectTo: '/apply/partner/bokadirekt' },
			{ path: 'existing-customer', redirectTo: '/getstarted' },
		],
	},
	{
		path: '',
		loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule),
		canActivate: [UnavailableGuard],
	},
	{
		path: 'contract',
		loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule),
		canActivate: [UnavailableGuard],
	},
	{
		path: 'unavailable',
		component: UnavailablePageComponent,
	},
	{
		path: '**',
		redirectTo: '/login',
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes, { enableTracing: environment.enableTracing })],
	exports: [RouterModule],
})
export class AppRoutingModule {}
